/**
 * 获取安全区
 */

var url = new URL(window.location.href)
var pTop = url.searchParams.get('pTop')
if (pTop) {
  localStorage.setItem('pTop', pTop)
}

var pBottom = url.searchParams.get('pBottom')
if (pBottom) {
  localStorage.setItem('pBottom', pBottom)
}

const hasCustomSafeArea = localStorage.getItem('pTop') !== null || localStorage.getItem('pBottom') !== null
const safeArea = {
  top: Number(localStorage.getItem('pTop') || 0),
  bottom: Number(localStorage.getItem('pBottom') || 0),
  left: 0,
  right: 0
}
if (hasCustomSafeArea) {
  document.body.style.setProperty('--safe-area-inset-top', `${safeArea.top}px`)
  document.body.style.setProperty('--safe-area-inset-bottom', `${safeArea.bottom}px`)
}

const safeAreaCalc = {
  top: 'var(--safe-area-inset-top)',
  bottom: 'var(--safe-area-inset-bottom)'
}
if (navigator.userAgent.toLowerCase().includes('flutter')) {
  safeAreaCalc.top = `${safeArea.top}px`
  safeAreaCalc.bottom = `${safeArea.bottom}px`
}

export const getSafeAreaTopStyle = (data = 0) => `calc(${safeAreaCalc.top} + ${data}px)`
export const getSafeAreaBottomStyle = (data = 0) => `calc(${safeAreaCalc.bottom} + ${data}px)`
export const getSafeAreaTop = () => safeArea.top
